import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { useTheme } from '../Themes';

import Shimmer from './Shimmer';
import styles from './Shimmer.styles';
import { shimmerPlaceholderConfig as _shimmerPlaceholderConfig } from './Shimmer.utils';

const ShimmerWrapper = ({
  isLoading,
  loadingConfig,
  shimmerPlaceholderConfig = _shimmerPlaceholderConfig,
  containerStyle,
}) => {
  const theme = useTheme();

  if (isLoading) {
    return (
      <View
        style={[styles.cardContainer(theme), containerStyle]}
        testID={FoundationTestKeys.shimmerWrapperView}
      >
        <Shimmer config={loadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
      </View>
    );
  }

  return null;
};

ShimmerWrapper.propTypes = {
  isLoading: PropTypes.bool,
  loadingConfig: PropTypes.array.isRequired,
  shimmerPlaceholderConfig: PropTypes.object,
  containerStyle: ViewPropTypes.style,
};

export default ShimmerWrapper;
